import React, { useEffect, useRef } from "react";

export default function BlobBackground() {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);
  const blobs = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let w = (canvas.width = window.innerWidth);
    let h = (canvas.height = window.innerHeight);

    const onResize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    window.addEventListener("resize", onResize);

    // Create soft blobs
    blobs.current = new Array(6).fill(0).map(() => ({
      x: Math.random() * w,
      y: Math.random() * h,
      r: 150 + Math.random() * 100,
      vx: (Math.random() - 0.5) * 0.6,
      vy: (Math.random() - 0.5) * 0.6,
      color: `hsla(${Math.random() * 360}, 80%, 65%, 0.5)`,
    }));

    const tick = () => {
      ctx.clearRect(0, 0, w, h);

      blobs.current.forEach((b) => {
        ctx.beginPath();
        ctx.fillStyle = b.color;
        ctx.arc(b.x, b.y, b.r, 0, Math.PI * 2);
        ctx.fill();

        b.x += b.vx;
        b.y += b.vy;
        if (b.x < -b.r) b.x = w + b.r;
        if (b.x > w + b.r) b.x = -b.r;
        if (b.y < -b.r) b.y = h + b.r;
        if (b.y > h + b.r) b.y = -b.r;
      });

      rafRef.current = requestAnimationFrame(tick);
    };

    tick();
    return () => {
      cancelAnimationFrame(rafRef.current);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="block fixed  top-0 left-0 w-full h-full -z-10 "
    />
  );
}
